/**
 * @description
 * handle the lenders signup form
 * @param {obj} args
 *
 * @param {array} GETparams
 * @param {string} controller
 * @param {string} agreements
 * @param {string} language
 */
var LenderOnboarding = function(args){
  this.GETparams = args.GETparams;
  this.controller = args.controller;
  this.agreements = args.agreements;
  this.language = args.language;
  this.params = ['firstname', 'lastname', 'email', 'referredBy', 'partner'];
  this.username = '';
  this.$firstname = $('#firstname');
  this.$lastname = $('#lastname');
  this.$email = $('#email');
  this.$password = $('#password');
  this.$havePartner = $('.have-partner');
  this.$partner = $('#partner');
  this.$checkPartner = $('.check-partner');
  this.$yes = $('#yes + label');
  this.$no = $('#no + label');
  this.$referredBy = $('#referredBy');
  this.$agreements = $('#agreements');
  this.$regulations = $('#regulations');
  this.$submit = $('#submit button');
  this.$gotit = $('button#gotit');
  this.$close = $('#close');
  this.observers();
  this.isRegulated;
  this.isReferrerRegulated();
  this.referralInfos = this.setReferralCookies();
  this.init();
}

/**
 * handle validation animations
 */
LenderOnboarding.prototype.fadePreviousSteps = function(observer){
  var fieldset = observer.parents('fieldset');
  while (fieldset.prev('fieldset').length > 0) {
    var prev = fieldset.prev('fieldset');
    this.fadeStep(prev);
    fieldset = prev;
  }
}

LenderOnboarding.prototype.fadeStep = function(step){
  if(step.hasClass('checked') && !step.find('input').is(':focus')){
    step.addClass('done');
    step.removeClass('edit');
    step.find('.errors').fadeOut('fast');
  }
}

LenderOnboarding.prototype.fadeNextSteps = function(observer){
  var fieldset = observer.parents('fieldset');
  while (fieldset.next('fieldset').length > 0) {
    var next = fieldset.next('fieldset');
    this.fadeStep(next);
    fieldset = next;
  }
}

/**
* fetch query params
* store it in cookies
* set referralInfos attribute (ARRAY)
*/
LenderOnboarding.prototype.setReferralCookies = function(){
  var _this = this;
  //-set cookies if query params exists
  $.each(_this.params, function(idx, param){
    if (_this.GETparams[param]) {
      Cookies.set(param, _this.GETparams[param], {expires: 1, secure: 'secure'});
    }
  });

  return this.setReferralInfos();
}

LenderOnboarding.prototype.setReferralInfos = function(){
  var _this = this;
  var referralInfos = {};
  //- populate referralInfos + prefill inputs + unhide prefilled fieldsets
  $.each(_this.params, function(idx, param) {
    referralInfos[param] = Cookies.get(param);
    $('#' + param).val(referralInfos[param]);

    if(referralInfos[param] && Cookies.get('firstname') && Cookies.get('lastname')){
      $('#' + param).parents('fieldset').addClass('active edit');
      $('#' + param).parents('fieldset').prev('fieldset').addClass('active edit');
      $('#' + param).parents('fieldset').next('fieldset:not(#referral, #send)').addClass('active edit');
    }

    if(referralInfos[param]){
      $('#' + param).addClass('callback');
    }
  });
  if(referralInfos['partner']){
    this.$referredBy.prop('disabled', true);
    this.$partner.text(referralInfos['partner']);
    this.$checkPartner.addClass('hidden');
    this.$havePartner.removeClass('hidden');
  }
  if( this.$referredBy.val() ){
    this.$yes.prev().prop('checked', true);
    $('.referral.yes').addClass('active');
  }
  return referralInfos;
}

/**
* AJAX CALL
* handle callbacks
*/
LenderOnboarding.prototype.createLender = function(){
  var _this = this;
  return $.post(
    _this.controller,
    {
      name: _this.username,
      email: _this.$email.val(),
      password: _this.$password.val(),
      referredBy: _this.$referredBy.val() || undefined,
      source: Cookies.get('source'),
      type: 'lender',
      settings: {agreements: [_this.agreements], language: _this.language}
    },
    'json'
  );
}

LenderOnboarding.prototype.submit = function(){
  var _this = this;
  if(this.validation()){
    //- send signup form
    var xhrSignup = this.createLender();
    //- if signup is OK -> replace form by confirmation message
    xhrSignup.done(function(callback){
      _this.success();
    });
    //- if signup is NOK -> distribute api's error messages with proper style
    xhrSignup.fail(function(callback){
      _this.clearInputStatuses();

      if(callback.responseJSON.errors){
        $.each(callback.responseJSON.errors, function(index, value){
          $('fieldset#' + index).removeClass('checked').addClass('edit');
          $('input#' + index).parents('fieldset').removeClass('checked').addClass('edit');
          $('article.errors.'+ index + ' .title').text(value);
          $('article.errors.'+ index).fadeIn('fast');
          $('input#' + index + ', fieldset#' + index + ' input').focus();
          $('input#' + index + ', fieldset#' + index + ' input').removeClass('valid').addClass('callback error');
          _this.$agreements.prop('checked', false);
        });

      }else if(callback.responseJSON.error){
        $('article.error .title').text(callback.responseJSON.error);
        $('article.error').fadeIn('fast');
        _this.$agreements.prop('checked', false);
      }
    });
  }
}

/**
 * successful ending
 * close the confirmation message / restore the form
 */
LenderOnboarding.prototype.success = function(){
  var _this = this;
  $('form.onboarding').removeClass('visible');
  $('form.success').addClass('visible');
  $('form.success .address').html(_this.$email.val());
  //- flush cookies
  $.each(_this.params, function(idx, param) {
    if (Cookies.get(param)) {
      Cookies.remove(param);
    }
  });
}

/**
 * reset input status
 */
LenderOnboarding.prototype.clearInputStatuses = function(){
  $('input.error:not(.callback)').removeClass('error');
  $('input.valid').removeClass('valid');
}

/**
 * DOM
 */
LenderOnboarding.prototype.close = function() {
  if(document.referrer.indexOf('october.eu') === -1){
    window.location.href = '/';
  }else{
    window.history.back();
  }
}

LenderOnboarding.prototype.keyPress = function(event) {
  if (event.keyCode === 13) {
    event.preventDefault();
  }
}
/**
 * intro animations
 * handle focus
 */
LenderOnboarding.prototype.init = function() {
  var _this = this;
  $('form.onboarding')
    .delay(500)
    .queue('fx', function() {
      $(this).addClass('visible');
      $(this).dequeue();
    })
    .find('#name')
    .delay(800)
    .queue('fx', function() {
      $(this).addClass('active');
      $(this).dequeue();

    })
    .next('#credentials')
    .delay(750)
    .queue('fx', function() {
      if( !$(this).hasClass('active') ){
        $(this).addClass('init');
      }
      $(this).dequeue();
    })
    .next('#referral')
    .delay(900)
    .queue('fx', function() {
      if( !$(this).hasClass('active') ){
        $(this).addClass('init');
      }
      $(this).dequeue();
    })
    .next('#send')
    .delay(1050)
    .queue('fx', function() {
      if( !$(this).hasClass('active') ){
        $(this).addClass('init');
      }
      $(this).dequeue();
      //focusing
      if( $('#referral').hasClass('active') ){
        _this.$password.focus();
      }else if ( $('#credentials').hasClass('active') ){
        _this.$email.focus();
      }else{
        _this.$firstname.focus();
      }
    })
    .parents('body')
    .find('footer')
    .delay(1200)
    .fadeIn('fast');

}
